import React from "react";
import { useTranslation } from "react-i18next"; // Importa il hook per la traduzione
import {
  Box,
  Typography,
  Stack,
  Rating,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ReviewSection = () => {
  const { t } = useTranslation(); // Usa il hook per accedere alla funzione t

  return (
    <Box
      sx={{
        padding: "20px",
        margin: "5%",
        backgroundColor: "#f5f5f5",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      {/* Sezione principale con punteggio e descrizione */}
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <StarIcon sx={{ fontSize: 40, color: "#FFD700" }} />
          <Typography variant="h6" color="textPrimary" fontWeight="bold">
            {t("reviewSection.ratedExcellent")} {/* Usa la traduzione */}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h4" fontWeight="bold" color="primary">
            9,3
          </Typography>
          <Rating value={4.6} precision={0.1} readOnly />
        </Stack>
        <Typography variant="subtitle1" color="textSecondary" mt={2}>
          {t("reviewSection.excellentScoreForNaples")} {/* Usa la traduzione */}
        </Typography>
      </Stack>

      {/* Accordion per tutte le categorie di valutazione */}
      <Accordion sx={{ mt: 2 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h7" fontWeight="bold">
            {t("reviewSection.ratingCategories")} {/* Usa la traduzione */}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t("reviewSection.staff")}: <strong>9,4</strong>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t("reviewSection.services")}: <strong>9,4</strong>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t("reviewSection.cleanliness")}: <strong>9,6</strong>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t("reviewSection.comfort")}: <strong>9,6</strong>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t("reviewSection.valueForMoney")}: <strong>9,1</strong>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t("reviewSection.location")}: <strong>9,5</strong>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t("reviewSection.freeWiFi")}: <strong>9,2</strong>
              </Typography>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ReviewSection;
